import type { Editor } from '@tiptap/react';
import { useCallback, useEffect, useRef, useState } from 'react';

type TeaEditorShortCutMessageProps = {
  editor: Editor;
};

export default function TeaEditorShortcutMessage({
  editor,
}: TeaEditorShortCutMessageProps) {
  const [tabPressedCount, setTabPressedCount] = useState(0);

  const refForSetTimeout = useRef<NodeJS.Timeout | null>(null);

  const handleTabPresses = useCallback(() => {
    setTabPressedCount((prevCount) => {
      if (prevCount === 0 && !refForSetTimeout.current) {
        refForSetTimeout.current = setTimeout(() => {
          setTabPressedCount(0);
          refForSetTimeout.current = null;
        }, 5000);
      }
      return prevCount + 1;
    });
  }, []);

  useEffect(() => {
    const tipTapEditor = editor?.view.dom;
    if (!tipTapEditor) return;

    function onKeyDown(event: KeyboardEvent) {
      if (
        editor?.isFocused &&
        event.key === 'Tab' &&
        !editor.isActive('tableCell')
      ) {
        handleTabPresses();
      }
    }

    tipTapEditor.addEventListener('keydown', onKeyDown);
    return () => {
      tipTapEditor.removeEventListener('keydown', onKeyDown);
    };
  }, [editor, handleTabPresses]);

  return (
    <div className="tea-editor-shortcut-message">
      {tabPressedCount > 2 ? 'Ctrl + Shift + M to focus formats toolbar.' : ''}
    </div>
  );
}
